import { render, staticRenderFns } from "./VxOptionsUUID.vue?vue&type=template&id=26334646"
import script from "./VxOptionsUUID.vue?vue&type=script&lang=js"
export * from "./VxOptionsUUID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports